export const PERSONAL_LOAN = 'personal';
export const VEHICLE_LOAN = 'vehicle';
export const MORTGAGE_LOAN = 'mortgage';
export const STUDENT_LOAN = 'student';
